import React from "react";
import { useHistory } from "react-router-dom";
import { Navbar, Nav, NavDropdown, Form, FormControl, Button } from "react-bootstrap";
import Logo from '../../assets/images/logo.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch , faBars} from '@fortawesome/free-solid-svg-icons';

function Header() {


    const history = useHistory();
    const pathname = history.location.pathname;


    return (

        <header className="main-padding" id="header">

            <Navbar bg="dark" variant="dark" expand="lg">
                <Navbar.Brand href="#"><img src={Logo} alt="Logo" className="img-fluid"/></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" >
                <FontAwesomeIcon icon={faBars} />
                </Navbar.Toggle>
                <Navbar.Collapse className=" justify-content-end" id="responsive-navbar-nav">
                    <Nav
                        className="mr-auto my-2 my-lg-0"
                    >
                        <Nav.Link className={`${pathname === '/' ? 'active' : ''}`} href="/">Explore</Nav.Link>
                        <Nav.Link className={`${pathname === '/marketplace' ? 'active' : ''}`} href="/">Marketplace</Nav.Link>
                        {/* <NavDropdown title="Link" id="navbarScrollingDropdown">
                            <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                            <NavDropdown.Item href="#action4">Another action</NavDropdown.Item>
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="#action5">Something else here</NavDropdown.Item>
                        </NavDropdown> */}
                        <Nav.Link className={`${pathname === '/resources' ? 'active' : ''}`} href="/">Resources</Nav.Link>
                        <Nav.Link className={`${pathname === '/create' ? 'active' : ''}`} href="/">Create</Nav.Link>
                    </Nav>
                    <Form className="d-flex align-items-center search-sec">
                        <div className="d-inline-block input-wrapper"><FormControl
                            type="text"
                            placeholder="Search"
                            className="mr-2"
                        /></div>
                        
                        <div className="icon"><FontAwesomeIcon icon={faSearch} /></div>
                    </Form>
                    <Button variant="primary">WALLET</Button>
                </Navbar.Collapse>
            </Navbar>

        </header>

    )
}
export default Header;